import { ReactNode } from 'react';

interface PanelProps {
  children: ReactNode;
}

const Panel = ({ children }: PanelProps): JSX.Element => {
  return (
    <div className="bg-lightBackground flex items-center flex-col py-6 px-16">
      <div className="max-w-full w-field gap-y-4 flex flex-col">{children}</div>
    </div>
  );
};

export default Panel;
